module.exports = __webpack_public_path__ + "media/images/home/card_courses-7a494d9d354673a61df2288ba61166bb.jpg";